// Page header (owner, 2026-10-21): no visible title, icon or lead line. The section bar and the
// sidebar already say where you are. The page's buttons move into the shell's top row, to the
// right of the section bar (slot #ady-page-actions), so no row is spent on them alone; outside the
// shell they stay here. The title and lead stay for screen readers (one h1 per page).
import { useLayoutEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

export const PAGE_ACTIONS_SLOT = "ady-page-actions";

export function PageHeader({
  title,
  lead,
  actions,
}: {
  title: ReactNode;
  lead?: ReactNode;
  actions?: ReactNode;
}) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useLayoutEffect(() => setSlot(document.getElementById(PAGE_ACTIONS_SLOT)), []);
  const buttons = actions ? (
    <div className="flex flex-wrap items-center gap-2">{actions}</div>
  ) : null;
  return (
    <>
      <header className="ady-sr-only">
        <h1>{title}</h1>
        {lead ? <p>{lead}</p> : null}
      </header>
      {buttons && slot ? (
        createPortal(buttons, slot)
      ) : buttons ? (
        <div className="flex justify-end">{buttons}</div>
      ) : null}
    </>
  );
}
